/*
 * The Frosted Muzzle — announcement bar dismissal (Phase 3 / Global Chrome)
 *
 * Dismissal is keyed in localStorage by a hash of the announcement content,
 * not a fixed key, so editing the message re-shows the bar for everyone.
 * Does not touch Dawn's pub/sub, global, or details-disclosure modules.
 */
class FMAnnouncementBar extends HTMLElement {
  constructor() {
    super();
    this.storageKey = `fm:announcement-dismissed:${this.hash(this.dataset.content || '')}`;
  }

  connectedCallback() {
    if (this.isDismissed()) {
      this.hideBar();
      return;
    }

    const closeButton = this.querySelector('[data-announcement-close]');
    if (closeButton) {
      closeButton.addEventListener('click', this.dismiss.bind(this));
    }
  }

  // Small, stable string hash (djb2). Enough to detect content changes.
  hash(str) {
    let h = 5381;
    for (let i = 0; i < str.length; i += 1) {
      h = (h * 33) ^ str.charCodeAt(i);
    }
    return (h >>> 0).toString(36);
  }

  isDismissed() {
    try {
      return window.localStorage.getItem(this.storageKey) === '1';
    } catch (e) {
      return false;
    }
  }

  dismiss() {
    try {
      window.localStorage.setItem(this.storageKey, '1');
    } catch (e) {
      // Private mode / storage disabled — dismiss for this view only.
    }
    this.hideBar();
  }

  hideBar() {
    this.hidden = true;
    document.dispatchEvent(new CustomEvent('fm:announcement:dismissed'));
  }
}

if (!customElements.get('fm-announcement-bar')) {
  customElements.define('fm-announcement-bar', FMAnnouncementBar);
}
